import { cx } from '@linaria/core'
import type { FC } from 'react'
import type { RecoverableConfiguration, TruckConfiguration } from '#app/store/slices/configurationSlice'
import { Icon } from '#components/Icon'
import { Spinner } from '#components/Spinner'
import CheckIcon from '#icons/check-24.svg'
import LockIcon from '#icons/lock-24.svg'
import UnsavedIcon from '#icons/unsaved-changes.svg'
import WarningIcon from '#icons/warning-filled.svg'
import { configurationStatus } from './configurationStatus'

export type ConfigurationStatus = ReturnType<typeof configurationStatus>

export const StatusIcon: FC<{ status: ConfigurationStatus; className?: string }> = ({ status, className }) => {
  switch (status) {
    case 'pending':
      return <Spinner className={cx('_status', '_spinner', className)} size="xxs" />
    case 'error':
      return <Icon iconUrl={WarningIcon} className={cx('_status', className)} size="xs" />
    case 'unsaved':
      return <Icon iconUrl={UnsavedIcon} className={cx('_status', className)} size="xs" />
    case 'read-only':
      return <Icon iconUrl={LockIcon} className={cx('_status', className)} size="xs" />
    case 'saved':
      return <Icon iconUrl={CheckIcon} className={cx('_status', className)} size="xs" />
  }
}

export const ConfigurationStatusIcon: FC<{
  configuration: TruckConfiguration | RecoverableConfiguration
  className?: string
}> = ({ configuration, className }) => {
  const status = configurationStatus(configuration)
  return <StatusIcon status={status} className={className} />
}
